/**
 * Fase 2B — LifecycleStatusBadge
 *
 * Herbruikbaar badge-component dat de lifecycle-status van een document
 * duidelijk maar rustig weergeeft. Kleurgebruik conform Fase 2A spec.
 */
import React from "react";
import { CheckCircle2, Copy, XCircle, History, FileEdit } from "lucide-react";

const STATUS_CONFIG = {
  concept: {
    label: "Concept",
    className: "bg-slate-100 text-slate-700 border-slate-300",
    Icon: FileEdit,
  },
  actief: {
    label: "Actief",
    className: "bg-emerald-50 text-emerald-800 border-emerald-300",
    Icon: CheckCircle2,
  },
  duplicaat: {
    label: "Duplicaat",
    className: "bg-amber-50 text-amber-800 border-amber-300",
    Icon: Copy,
  },
  geannuleerd: {
    label: "Geannuleerd",
    className: "bg-rose-50 text-rose-800 border-rose-300",
    Icon: XCircle,
  },
  vervangen: {
    label: "Vervangen",
    className: "bg-zinc-100 text-zinc-700 border-zinc-300",
    Icon: History,
  },
};

export default function LifecycleStatusBadge({ status, size = "default", showIcon = true, className = "" }) {
  const cfg = STATUS_CONFIG[status];
  if (!cfg) return null;
  const { label, className: statusCls, Icon } = cfg;
  const sizeCls = size === "sm"
    ? "text-[10px] px-1.5 py-0.5"
    : "text-xs px-2 py-1";
  const iconSize = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5";
  return (
    <span
      className={`inline-flex items-center gap-1 border rounded-none font-bold ${statusCls} ${sizeCls} ${className}`}
      data-testid={`lifecycle-badge-${status}`}
    >
      {showIcon && <Icon className={iconSize} />}
      {label}
    </span>
  );
}
